import React, { Component } from 'react';
import _ from 'lodash';
import Hypertension from './dashboardTabs/Hypertension'
import Diabities from './dashboardTabs/Diabities'
import CardioVascularDiseases from './dashboardTabs/CardioVascularDiseases'
import Charts from '../common/Charts'
import { Breadcrumb } from '../common/atoms';
import { Row, Col, Tabs, Spin, Popover, Card} from 'antd';
// import ZingChart from 'zingchart-react';

const TabPane = Tabs.TabPane;

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wellness_score: '',
            optimal_score: '',
            filters: [],
            config: {},
            isLoading: true,
            wellnessScoreOverall: {filters: [],config: {}},
            wellnessScoreDeptLoc: {filters: [],config: {}},
            healthParameterImpact: {filters: [],config: {}},
            wellnessScoreIndustry: {filters: [],config: {}},
            employee_comorbidities: {},
            baseConfig: {
              filters: [],
              config: {
                chart: {renderTo: 'container'},
                title: {text: 'Wellness Score', align: 'left', margin: 35},
                subtitle: {text: '', align: 'left'},
                xAxis: {},
                yAxis: {},
                credits: {
                  enabled: false
                },
                series: [],
                plotOptions: {}
              }
            }
        };
        this.wellnessScoreDepartmentCallback = this.wellnessScoreDepartmentCallback.bind(this)
        this.wellnessScoreIndustryCallback = this.wellnessScoreIndustryCallback.bind(this)
        this.myConfig = {
            "type":"venn",
            "plot":{
              "value-box":{
                "text":"%t:<br>%v",
                "joined":{
                  "text":"Joined:<br>%joined-value"
                },
                "shared":{
                  "text":"Shared:<br>%shared-value"
                }
              }
            },
            "series":[
              {
                "values":[16],
                "join":[4],
                "text":"Set One"
              },
              {
                "values":[16],
                "join":[3],
                "text":"Set Two"
              },
              {
                "values":[12],
                "join":[4],
                "text":"Set Three"
              }
            ]
          };
    }
    componentWillMount () {
        this.getWellnessScoreOverallConfig()
        this.getWellnessScoreDepartmentConfig()
        this.getHealthParameterImpactConfig()
        this.getWellnessScoreIndustryConfig()
        this.getEmployeeComorbities()
    }
    callback(key) {
        // console.log(key);
    }
    getWellnessScoreIndustryConfig () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.config.subtitle.text = 'Industry wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/wellness/company_wise')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.chart.type = 'column'
        baseConfig.config.chart.className = 'industry-score-chart'
        baseConfig.config.xAxis = series.xAxis
        baseConfig.config.yAxis = series.yAxis
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        console.log(response.data)
        that.setState({wellnessScoreIndustry: baseConfig, allWellnessScoreIndustry: response.data, isLoading: false})
      })
      .catch(function (error) {
        console.log(error);
      })
    }
    wellnessScoreIndustryCallback (filter) {
      let series = this.state.allWellnessScoreIndustry.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allWellnessScoreIndustry.filters
      baseConfig.config.subtitle.text = 'Industry wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.chart.type = 'column'
      baseConfig.config.xAxis = series.xAxis
      baseConfig.config.yAxis = series.yAxis
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({wellnessScoreIndustry: baseConfig})
    } 

    getHealthParameterImpactConfig () {
      let that = this
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.config.subtitle.text = 'Health parameter impacts on score'
      window.axios.get(window.API_URL + 'corporate/dashboard/wellness/wellness_impacts')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        baseConfig.config.chart.type = 'column'
        baseConfig.config.xAxis = response.data.xAxis
        baseConfig.config.yAxis = response.data.yAxis
        baseConfig.config.series = response.data.series
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({healthParameterImpact: baseConfig})
      })
      .catch(function (error) {
        console.log(error);
      })
    }
    getWellnessScoreDepartmentConfig () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.config.subtitle.text = 'Location & Department wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/wellness/wellness_filtered')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.chart.type = 'column'
        baseConfig.config.xAxis = series.xAxis
        baseConfig.config.yAxis = series.yAxis
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({wellnessScoreDeptLoc: baseConfig, allWellnessScoreDeptLoc: response.data})
      })
      .catch(function (error) {
        console.log(error);
      })
    }
    wellnessScoreDepartmentCallback (filter) {
      let series = this.state.allWellnessScoreDeptLoc.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allWellnessScoreDeptLoc.filters
      baseConfig.config.subtitle.text = 'Location & Department wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      baseConfig.config.chart.type = 'column'
      baseConfig.config.xAxis = series.xAxis
      baseConfig.config.yAxis = series.yAxis
      this.setState({wellnessScoreDeptLoc: baseConfig})
    }

    getWellnessScoreOverallConfig () {
      let that = this
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.config.subtitle.text = 'Actual vs Optimum'
      window.axios.get(window.API_URL + 'corporate/dashboard/wellness/wellness_score')
      .then(function (response) {
        baseConfig.filters = []
        baseConfig.config.chart.type = 'bar'
        baseConfig.config.chart.className = 'overall-score-chart'
        baseConfig.config.series = response.data.series
        baseConfig.config.series[0].data = [response.data.series[0].data]
        baseConfig.config.plotOptions = {bar: {maxPointWidth: 31}}
        // baseConfig.config.series[0].color = 'rgb(255, 227, 117)'
        // baseConfig.config.series[1].color = 'rgb(0, 196, 212)'
        baseConfig.config.series[1].data = [response.data.series[1].data]
        that.setState({wellnessScoreOverall: baseConfig, wellness_score: response.data.series[0].data, optimal_score: response.data.series[1].data})
      })
      .catch(function (error) {
        console.log(error);
      })
    }

    getEmployeeComorbities(){
      let that = this
      window.axios.get(window.API_URL + 'corporate/dashboard/wellness/employee_comorbidities')
      .then(function (response) {
        that.setState({employee_comorbidities: response.data.series})
      })
      .catch(function (error) {
        console.log(error);
      })
    }



    renderVenn(){
      return(
        <svg version='1.1' class='highcharts-root' style={{enableBackground: "new 0 0 500 330;"}} viewBox="0 0 500 330" width="500" height="330" xmlns="http://www.w3.org/2000/svg">
          <circle className="st0" cx="113.8" cy="117.9" r="92.8" fill='#F2CA5C' fillOpacity='0.80'></circle>
          <circle className="st1" cx="246.2" cy="117.9" r="92.8" fill='#536DFE' fillOpacity='0.80'></circle>
          <circle className="st2" cx="190.7" cy="222.1" r="92.8" fill='#00C4D4' fillOpacity='0.80'></circle>
          <Popover content={this.state.employee_comorbidities.h + ' employees have hypertension'} title="">
            <text className="st3 st4 st5" transform="matrix(1 0 0 1 101.5991 117.9202)" fill="#FFFFFF">
              {this.state.employee_comorbidities.h}
            </text>
          </Popover>  
          <Popover content={this.state.employee_comorbidities.hd + ' employees have hypertension & diabetes'} title="">
          <text className="st3 st4 st5" transform="matrix(1 0 0 1 168.5991 115.9202)" fill="#FFFFFF">
          {this.state.employee_comorbidities.hd}
          </text>
          </Popover>
          <Popover content={this.state.employee_comorbidities.d + ' employees have diabetes'} title="">
          <text className="st3 st4 st5" transform="matrix(1 0 0 1 250.5991 125.9204)" fill="#FFFFFF">
          {this.state.employee_comorbidities.d}
          </text>
          </Popover>
          <Popover content={this.state.employee_comorbidities.hdo + ' employees have hypertension, diabetes & obesity'} title="">
          <text className="st3 st4 st5" transform="matrix(1 0 0 1 170.5991 160.9203)" fill="#FFFFFF">
          {this.state.employee_comorbidities.hdo}
          </text>
          </Popover>
          <Popover content={this.state.employee_comorbidities.do + ' employees have diabetes & obesity'} title="">
          <text className="st3 st4 st5" transform="matrix(1 0 0 1 217.8163 182.9203)" fill="#FFFFFF">
          {this.state.employee_comorbidities.do}
          </text>
          </Popover>
          <Popover content={this.state.employee_comorbidities.ho + ' employees have hypertension & obesity'} title="">
          <text className="st3 st4 st5" transform="matrix(1 0 0 1 125.8163 182.9207)" fill="#FFFFFF">
          {this.state.employee_comorbidities.ho}
          </text>
          </Popover>
          <Popover content={this.state.employee_comorbidities.o + ' employees have obesity'} title="">
          <text className="st3 st4 st5" transform="matrix(1 0 0 1 180.8162 250.9202)" fill="#FFFFFF">
          {this.state.employee_comorbidities.o}
          </text>
          </Popover>
          <circle className="st0" cx="370.8" cy="117.9" r="5" fill='#F2CA5C'></circle>
          <circle className="st1" cx="370.8" cy="137.9" r="5" fill='#536DFE'></circle>
          <circle className="st2" cx="370.8" cy="157.9" r="5" fill='#00C4D4'></circle>
          <text className="st4 venn-text" transform="matrix(1 0 0 1 380.5991 121.9202)">
          Hypertensive
          </text>
          <text className="st4 venn-text" transform="matrix(1 0 0 1 380.5991 141.9202)">
          Diabetic
          </text>
          <text className="st4 venn-text" transform="matrix(1 0 0 1 380.5991 161.9202)">
          Obese
          </text>
          </svg>
      )
    }   
    
    render () {
        if(this.state.isLoading) {
            return (
              <div className="spiner">
                <Spin size="large"/>
              </div>
            )
        }
        return (
          <div>
            <Row>
              <Col span={12}>
              <Breadcrumb list={[{ text: 'Analytics', link: '#' }, { text: this.props.breadcrumb_text || 'Dashboard', link: '/dashboard' }]} classes='mb-1' />
              </Col>
              <Col span={12}>
                <Row type="flex" justify="end" style={{marginTop: 10}}>
                  <h4 className="top-right-delay-label">Refreshes every <b> day </b></h4>
                </Row>
              </Col>
            </Row>  
            <div className="gutter-example">
                <Card>
                  <Row gutter={16}>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              {/* <Row type="flex" justify="space-around" align="middle" > */}
                                  {/* <Col span={8}> */}
                                  <Charts filters={this.state.wellnessScoreOverall.filters} config={this.state.wellnessScoreOverall.config}/>
                                  {/* </Col> */}
                              {/* </Row> */}
                              {/* <div className="wellnessScoreText">
                                  Current score is the aggregated organization level score, while Optimum score is the best score achievable by taking healthy actions
                              </div>   */}
                          </div>
                      </Col>
                      <Col span={2}/>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts
                                callback={this.wellnessScoreDepartmentCallback} 
                                filters={this.state.wellnessScoreDeptLoc.filters} 
                                config={this.state.wellnessScoreDeptLoc.config} />
                          </div>
                      </Col>
                  </Row>
                </Card>
                <br></br>
                <Card>
                  <Row gutter={16}>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts filters={this.state.healthParameterImpact.filters} config={this.state.healthParameterImpact.config}/>
                          </div>
                      </Col>
                      <Col span={2}/>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts 
                              callback={this.wellnessScoreIndustryCallback} 
                              filters={this.state.wellnessScoreIndustry.filters} 
                              config={this.state.wellnessScoreIndustry.config} />
                          </div>
                      </Col>
                  </Row>
                </Card>
                <br></br>
                <Card>
                  <Row gutter={16}>
                      <h2 className='semibold'> Employee - comorbidities </h2>
                      <h5 className='semibold' style={{marginTop: '-13px', color: '#6B7280'}}> Hypertension, Diabetes & Obesity distribution </h5>
                      <Col className="gutter-row" span={12}>
                          <div className="gutter-box employee-comorbidities-chart">
                              {this.renderVenn()}
                          </div>
                      </Col>
                     
                  </Row>
                </Card>
                <br></br>
                <Row gutter={16}>
                    <Tabs defaultActiveKey="1" onChange={this.callback.bind(this)} >
                        <TabPane tab="Hypertension" key="1">
                            <Hypertension />
                        </TabPane>
                        <TabPane tab="Diabetes" key="2">
                            <Diabities />
                        </TabPane>
                        <TabPane tab="Cardio Vascular Diseases(CVD)" key="3">
                            <CardioVascularDiseases />
                        </TabPane>
                    </Tabs>         
                </Row>
                <br></br>
                <input type='hidden' id="wellnessScore" value={this.state.wellness_score} />
                <input type='hidden' id="optimalScore" value={this.state.optimal_score} />
            </div>
          </div>   
        )
    }
}
export default Dashboard;